import { all, fork } from 'redux-saga/effects';

import listenLoad from './listenLoad';
import listenLoadMore from './listenLoadMore';

export default function* myTripsSaga() {
  yield all([fork(listenLoad), fork(listenLoadMore)]);
}
